<template>
  <div class="breadcrumb-wrapper">
    <div class="container-fluid">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb px-0">
          <li
            v-for="(item, index) in data.breadcrumbItems"
            :key="'breadcrumb' + index"
            class="breadcrumb-item"
          >
            <span v-if="index == data.breadcrumbItems.length - 1">
              {{ item.text }}
            </span>
            <span v-else>
              <a :href="item.url" class="ltr-underline">{{ item.text }}</a>
            </span>
          </li>
        </ol>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      required: true
    }
  }
};
</script>
